import React, { useEffect, useState } from 'react';

const BiryaniLanding = () => {
  const [aromas, setAromas] = useState([]);

  // Styles as JavaScript objects
  const styles = {
    container: {
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #0f0600 0%, #1f0f05 100%)',
      color: '#fff',
      overflow: 'hidden',
      position: 'relative',
      fontFamily: '"Cormorant Garamond", serif',
      padding: '1rem',
    },
    content: {
      textAlign: 'center',
      zIndex: 10,
      position: 'relative',
      maxWidth: '800px',
      width: '100%',
      padding: '3rem 2rem',
      background: 'rgba(0, 0, 0, 0.15)',
      backdropFilter: 'blur(12px)',
      borderRadius: '2px',
      border: '1px solid rgba(255, 165, 75, 0.1)',
      boxShadow: '0 0 60px rgba(255, 140, 0, 0.08)',
    },
    brandName: {
      fontFamily: '"Cormorant Garamond", serif',
      fontSize: 'clamp(2rem, 12vw, 5.5rem)',
      fontWeight: 600,
      color: '#ffcc99',
      letterSpacing: 'clamp(0.05em, 2vw, 0.25em)',
      marginBottom: '1.5rem',
      textTransform: 'uppercase',
      lineHeight: '1.1',
      wordBreak: 'keep-all',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    ornament: {
      width: '120px',
      height: '2px',
      background: 'linear-gradient(90deg, transparent, #ff9933, transparent)',
      margin: '0 auto 2.5rem',
    },
    tagline: {
      fontSize: 'clamp(0.8rem, 4vw, 1.4rem)',
      fontWeight: 300,
      color: '#ffd9b3',
      letterSpacing: 'clamp(0.05em, 1vw, 0.15em)',
      textTransform: 'uppercase',
      marginBottom: '3.5rem',
      fontStyle: 'italic',
      lineHeight: '1.4',
    },
    comingSoon: {
      padding: '2rem 0',
      marginBottom: '3rem',
    },
    comingSoonText: {
      fontSize: 'clamp(1rem, 6vw, 1.8rem)',
      fontWeight: 400,
      letterSpacing: 'clamp(0.1em, 1.5vw, 0.35em)',
      textTransform: 'uppercase',
      color: '#ffcc99',
      margin: 0,
      wordBreak: 'keep-all',
    },
    instruction: {
      fontSize: '0.9rem',
      color: 'rgba(255, 217, 179, 0.6)',
      marginTop: '3.5rem',
      letterSpacing: '0.1em',
      textTransform: 'uppercase',
    },
    aromaEffect: {
      position: 'absolute',
      borderRadius: '50%',
      background: 'radial-gradient(circle, rgba(255,179,102,0.15) 0%, rgba(230,126,34,0.05) 70%, rgba(230,126,34,0) 100%)',
      opacity: 0,
      zIndex: 3,
      pointerEvents: 'none',
    },
    goldAccent: {
      position: 'absolute',
      top: '30%',
      right: '10%',
      width: '1px',
      height: '80px',
      background: 'linear-gradient(to bottom, transparent, #ff9933, transparent)',
      opacity: 0.5,
    },
    goldAccent2: {
      position: 'absolute',
      bottom: '30%',
      left: '10%',
      width: '1px',
      height: '80px',
      background: 'linear-gradient(to bottom, transparent, #ff9933, transparent)',
      opacity: 0.5,
    },
    // Keyframes as style tag content
    keyframes: `
      @keyframes fadeIn {
        from { opacity: 0; transform: translateY(20px); }
        to { opacity: 1; transform: translateY(0); }
      }
      @keyframes aroma {
        0% {
          transform: scale(0.5);
          opacity: 0.5;
        }
        100% {
          transform: scale(3);
          opacity: 0;
        }
      }
      @keyframes subtlePulse {
        0% { opacity: 0.4; }
        50% { opacity: 0.7; }
        100% { opacity: 0.4; }
      }
    `,
    // Media queries
    mediaQueries: `
      @media (max-width: 768px) {
        .container {
          padding: 0.5rem;
        }
        .content {
          max-width: 100%;
          padding: 2rem 1rem;
          margin: 0.5rem;
        }
        .brand-name {
          font-size: clamp(1.8rem, 10vw, 3.5rem) !important;
          letter-spacing: clamp(0.02em, 1.5vw, 0.15em) !important;
          margin-bottom: 1rem;
          word-break: normal;
          white-space: normal;
          overflow: visible;
        }
        .coming-soon-text {
          font-size: clamp(0.9rem, 5vw, 1.4rem) !important;
          letter-spacing: clamp(0.05em, 1vw, 0.25em) !important;
        }
        .tagline {
          font-size: clamp(0.7rem, 3.5vw, 1.1rem) !important;
          letter-spacing: clamp(0.02em, 0.8vw, 0.1em) !important;
          margin-bottom: 2rem;
        }
        .ornament {
          width: 60px;
          margin-bottom: 1.5rem;
        }
        .coming-soon {
          padding: 1rem 0;
          margin-bottom: 1.5rem;
        }
      }
      
      @media (max-width: 375px) {
        .content {
          padding: 1.5rem 0.8rem;
          margin: 0.25rem;
        }
        .brand-name {
          font-size: clamp(1.6rem, 9vw, 2.8rem) !important;
          letter-spacing: clamp(0.01em, 1vw, 0.1em) !important;
          margin-bottom: 0.8rem;
        }
        .coming-soon-text {
          font-size: clamp(0.8rem, 4.5vw, 1.2rem) !important;
          letter-spacing: clamp(0.02em, 0.8vw, 0.15em) !important;
        }
        .tagline {
          font-size: clamp(0.65rem, 3vw, 0.9rem) !important;
          letter-spacing: clamp(0.01em, 0.5vw, 0.08em) !important;
        }
        .ornament {
          width: 50px;
        }
      }
      
      @media (max-width: 320px) {
        .content {
          padding: 1.2rem 0.5rem;
          margin: 0.1rem;
        }
        .brand-name {
          font-size: clamp(1.4rem, 8vw, 2.4rem) !important;
          letter-spacing: clamp(0.01em, 0.8vw, 0.08em) !important;
        }
        .coming-soon-text {
          font-size: clamp(0.7rem, 4vw, 1rem) !important;
          letter-spacing: clamp(0.01em, 0.6vw, 0.1em) !important;
        }
        .tagline {
          font-size: clamp(0.6rem, 2.8vw, 0.8rem) !important;
          letter-spacing: clamp(0.01em, 0.4vw, 0.05em) !important;
        }
        .ornament {
          width: 40px;
        }
      }
      
      /* Landscape orientation on mobile */
      @media (max-width: 900px) and (orientation: landscape) and (max-height: 500px) {
        .container {
          padding: 0.25rem;
        }
        .content {
          padding: 1rem 2rem;
          max-width: 80%;
        }
        .brand-name {
          font-size: clamp(1.5rem, 8vw, 2.5rem) !important;
          margin-bottom: 0.5rem;
        }
        .coming-soon-text {
          font-size: clamp(0.9rem, 4vw, 1.2rem) !important;
        }
        .tagline {
          font-size: clamp(0.7rem, 3vw, 0.9rem) !important;
          margin-bottom: 1rem;
        }
        .coming-soon {
          padding: 0.5rem 0;
          margin-bottom: 0.5rem;
        }
      }
    `,
  };

  // Handle mouse move to create subtle aroma effects
  const handleMouseMove = (e) => {
    // Only create aroma effect occasionally for minimalism
    if (Math.random() > 0.7) {
      const newAroma = {
        id: Date.now(),
        x: e.clientX,
        y: e.clientY,
        size: 10 + Math.random() * 20,
      };
      setAromas((prev) => [...prev, newAroma]);
      
      // Remove aroma after animation completes
      setTimeout(() => {
        setAromas((prev) => prev.filter((aroma) => aroma.id !== newAroma.id));
      }, 2000);
    }
  };

  return (
    <div style={styles.container} className="container" onMouseMove={handleMouseMove}>
      {/* Add keyframes and media queries */}
      <style>
        {styles.keyframes}
        {styles.mediaQueries}
      </style>
      
      {/* Decorative elements */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: `radial-gradient(circle at 15% 20%, rgba(80, 40, 10, 0.1) 0px, transparent 50%),
                    radial-gradient(circle at 85% 80%, rgba(100, 50, 15, 0.1) 0px, transparent 50%)`,
        zIndex: 1,
      }}></div>
      
      {/* Subtle gold accents */}
      <div style={styles.goldAccent}></div>
      <div style={styles.goldAccent2}></div>
      
      {/* Aroma effects */}
      {aromas.map((aroma) => (
        <div
          key={aroma.id}
          style={{
            ...styles.aromaEffect,
            left: aroma.x - aroma.size/2,
            top: aroma.y - aroma.size/2,
            width: aroma.size,
            height: aroma.size,
            animation: 'aroma 2s ease-out forwards',
          }}
        />
      ))}
      
      <div style={styles.content} className="content">
        <h1 style={{...styles.brandName, animation: 'fadeIn 1.5s ease-out'}} className="brand-name">BIRYANI</h1>
        
        <div style={styles.ornament} className="ornament"></div>
        
        <p style={{...styles.tagline, animation: 'fadeIn 1.5s ease-out 0.3s both'}} className="tagline">A Royal Culinary Experience</p>
        
        <div style={styles.comingSoon} className="coming-soon">
          <h2 style={{...styles.comingSoonText, animation: 'fadeIn 1.5s ease-out 0.6s both'}} className="coming-soon-text">COMING SOON</h2>
        </div>

       </div>

      {/* Subtle particles in the background - fewer on mobile */}
      {[...Array(window.innerWidth > 768 ? 5 : 3)].map((_, i) => (
        <div key={i} style={{
          position: 'absolute',
          width: '3px',
          height: '3px',
          borderRadius: '50%',
          background: '#ff9933',
          opacity: 0.4,
          top: `${20 + i * 15}%`,
          left: `${10 + i * 5}%`,
          animation: 'subtlePulse 4s infinite ease-in-out',
          animationDelay: `${i * 0.5}s`
        }}></div>
      ))}
      
      {[...Array(window.innerWidth > 768 ? 5 : 3)].map((_, i) => (
        <div key={i+10} style={{
          position: 'absolute',
          width: '3px',
          height: '3px',
          borderRadius: '50%',
          background: '#ff9933',
          opacity: 0.4,
          bottom: `${20 + i * 15}%`,
          right: `${10 + i * 5}%`,
          animation: 'subtlePulse 4s infinite ease-in-out',
          animationDelay: `${i * 0.7}s`
        }}></div>
      ))}
    </div>
  );
};

export default BiryaniLanding;